export default class QuantitySelector extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.productForm = this.closest("form");
    this.quantityInput = this.productForm.querySelector(
      "input[name='quantity']",
    );

    this.quantityDisplayAll = document.querySelectorAll(
      "[data-quantity-display]",
    );
    this.quantityDisplay = this.querySelector("[data-quantity-display]");

    this.minusButton = this.querySelector("[data-quantity-minus]");
    this.plusButton = this.querySelector("[data-quantity-plus]");

    this.handleMinusClick = this.handleMinusClick.bind(this);
    this.handlePlusClick = this.handlePlusClick.bind(this);

    this.minusButton.addEventListener("click", this.handleMinusClick);
    this.plusButton.addEventListener("click", this.handlePlusClick);
  }

  disconnectedCallback() {
    this.minusButton.removeEventListener("click", this.handleMinusClick);
    this.plusButton.removeEventListener("click", this.handlePlusClick);
  }

  handleMinusClick() {
    if (parseInt(this.quantityDisplay.textContent) === 1) {
      return;
    }
    this.quantityDisplayAll.forEach((quantity) => {
      quantity.textContent = parseInt(quantity.textContent) - 1;
    });
    this.quantityInput.value = parseInt(this.quantityInput.value) - 1;

    this.updateAtcButtonPrice(this.quantityInput.value);
  }

  handlePlusClick() {
    if (
      parseInt(this.quantityDisplay.textContent) === parseInt(this.maxQuantity)
    ) {
      return;
    }
    this.quantityDisplayAll.forEach((quantity) => {
      quantity.textContent = parseInt(quantity.textContent) + 1;
    });
    this.quantityInput.value = parseInt(this.quantityInput.value) + 1;

    this.updateAtcButtonPrice(this.quantityInput.value);
  }
  updateAtcButtonPrice(quantity) {
    const productPriceAll = document.querySelectorAll("[data-product-price]");
    const productPrice = document.querySelector("#product-price");

    productPriceAll.forEach((price) => {
      price.innerHTML = Shopify.customFormatMoney(
        productPrice.dataset.productPrice * quantity,
        "{{amount}}",
      );
    });
  }
}

customElements.define("quantity-selector", QuantitySelector);
